export default {

	state: {
		assets: [],

		campaigns: [],

		checkin_types: [],

		routes: [],

		states: [
			{ id: 'AL', label: 'AL' },
			{ id: 'AK', label: 'AK' },
			{ id: 'AR', label: 'AR' },
			{ id: 'AZ', label: 'AZ' },
			{ id: 'CA', label: 'CA' },
			{ id: 'CO', label: 'CO' },
			{ id: 'CT', label: 'CT' },
			{ id: 'DC', label: 'DC' },
			{ id: 'DE', label: 'DE' },
			{ id: 'FL', label: 'FL' },
			{ id: 'GA', label: 'GA' },
			{ id: 'HI', label: 'HI' },
			{ id: 'IA', label: 'IA' },
			{ id: 'ID', label: 'ID' },
			{ id: 'IL', label: 'IL' },
			{ id: 'IN', label: 'IN' },
			{ id: 'KS', label: 'KS' },
			{ id: 'KY', label: 'KY' },
			{ id: 'LA', label: 'LA' },
			{ id: 'MA', label: 'MA' },
			{ id: 'MD', label: 'MD' },
			{ id: 'ME', label: 'ME' },
			{ id: 'MI', label: 'MI' },
			{ id: 'MN', label: 'MN' },
			{ id: 'MO', label: 'MO' },
			{ id: 'MS', label: 'MS' },
			{ id: 'MT', label: 'MT' },
			{ id: 'NC', label: 'NC' },
			{ id: 'NE', label: 'NE' },
			{ id: 'NH', label: 'NH' },
			{ id: 'NJ', label: 'NJ' },
			{ id: 'NM', label: 'NM' },
			{ id: 'NV', label: 'NV' },
			{ id: 'NY', label: 'NY' },
			{ id: 'ND', label: 'ND' },
			{ id: 'OH', label: 'OH' },
			{ id: 'OK', label: 'OK' },
			{ id: 'OR', label: 'OR' },
			{ id: 'PA', label: 'PA' },
			{ id: 'RI', label: 'RI' },
			{ id: 'SC', label: 'SC' },
			{ id: 'SD', label: 'SD' },
			{ id: 'TN', label: 'TN' },
			{ id: 'TX', label: 'TX' },
			{ id: 'UT', label: 'UT' },
			{ id: 'VT', label: 'VT' },
			{ id: 'VA', label: 'VA' },
			{ id: 'WA', label: 'WA' },
			{ id: 'WI', label: 'WI' },
			{ id: 'WV', label: 'WV' },
			{ id: 'WY', label: 'WY' },
		],

		service_lines: [],

		specialties: [],

		user_ids: [],
    },

	actions: {
		fetchOptions({commit}) {
			axios.get('/api/options').then(({data}) => {
				commit('setCheckinTypes', data.checkin_types);
				commit('setServiceLines', data.service_lines);
				commit('setSpecialties', data.specialties);
				commit('setUserIds', data.user_ids);
			});
		},

		fetchAssets({commit, state}) {
			if (state.assets === undefined || state.assets.length == 0){
				axios.get('/api/assets/ids').then(({data}) => {			
					commit('setAssets', data);
				});
			}
		},

		fetchCampaigns({commit, state}) {
			if (state.campaigns === undefined || state.campaigns.length == 0){
				axios.get('/api/campaigns/user').then(({data}) => {		
					commit('setCampaigns', data);
				});
			}
		},

		fetchRoutes({commit, state}) {
			if (state.routes === undefined || state.routes.length == 0){
				axios.get('/api/routes/user').then(({data}) => {		
					commit('setRoutes', data);
				});
			}
		},

		fetchServiceLines({commit, state}) {
			if (state.service_lines === undefined || state.service_lines.length == 0){
				axios.get('/api/service-lines').then(({ data }) => {
					commit('setServiceLines', data);
				});
			}
		},

		fetchSpecialties({commit, state}) {
			if (state.specialties === undefined || state.specialties.length == 0){
				axios.get('/api/specialties').then(({ data }) => {
					commit('setSpecialties', data);
				});
			}
		},

		fetchUserIds({commit, state}) {
			if (state.user_ids === undefined || state.user_ids.length == 0){
				axios.get('/api/admin/users/ids').then(({ data }) => {
					commit('setUserIds', data);
				});
			}
		},



		//*** REFRESH EVERYTHING ***//
		refreshAssets({commit}) {
			axios.get('/api/assets/ids').then(({data}) => {			
				commit('setAssets', data);
			});
		},

		refreshCampaigns({commit}) {
			axios.get('/api/campaigns/ids').then(({data}) => {		
				commit('setCampaigns', data);
			});
		},

		refreshRoutes({commit}) {
			axios.get('/api/routes/ids').then(({data}) => {		
				commit('setRoutes', data);
			});
		},

		refreshServiceLines({commit}) {
			axios.get('/api/service-lines').then(({ data }) => {
				commit('setServiceLines', data);
			});
		},

		refreshSpecialties({commit}) {
			axios.get('/api/specialties').then(({ data }) => {
				commit('setSpecialties', data);
			});
		},

		refreshUserIds({commit}) {
			axios.get('/api/admin/users/ids').then(({ data }) => {
				commit('setUserIds', data);
			});
		},	

	},

    mutations: {
		setAssets(state, assets) {
			state.assets = assets;			
		},

		setCampaigns(state, campaigns) {
			state.campaigns = campaigns;
			this.state.config.loaded.campaigns = true;
		},

		setCheckinTypes(state, checkin_types) {
			state.checkin_types = checkin_types;
		},

		setRoutes(state, routes) {
			state.routes = routes;
			this.state.config.loaded.routes = true;
		},
 
		setServiceLines(state, service_lines) {
			state.service_lines = service_lines;
		},

		setSpecialties(state, specialties) {
			state.specialties = specialties;
			this.state.config.loaded.options = true;
		},

		setUserIds(state, user_ids) {
			state.user_ids = user_ids;
			this.state.config.loaded.accounts = true;
		},

    },

    getters: {
		allProviderIds(state, getters) {
			return [...getters.allGroupIds, ...getters.allPhysicianIds].sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		mappableProviderIds(state, getters) {
			return [...getters.mappableGroupIds, ...getters.mappablePhysicianIds].sort((a, b) => a.display_name.localeCompare(b.display_name));
		},

		nearbyProviderIds: (state, getters) => (params) => {
			return [...getters.nearbyGroupIds(params), ...getters.nearbyPhysicianIds(params)].sort((a, b) => a.display_name.localeCompare(b.display_name));
		}
    }
};